/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationUserDto } from "../models/ApplicationUserDto";
import type { ApplicationUserDtoPaginatedResultDto } from "../models/ApplicationUserDtoPaginatedResultDto";
import type { ApplicationUserResultDto } from "../models/ApplicationUserResultDto";
import type { Coupon } from "../models/Coupon";
import type { CouponDto } from "../models/CouponDto";
import type { CouponPaginatedResultDto } from "../models/CouponPaginatedResultDto";
import type { CouponRequestResultDto } from "../models/CouponRequestResultDto";
import type { CouponResultDto } from "../models/CouponResultDto";
import type { KPIFilterType } from "../models/KPIFilterType";
import type { Modul } from "../models/Modul";
import type { PaymentTransactionLog } from "../models/PaymentTransactionLog";
import type { ResultDto } from "../models/ResultDto";
import type { TransactionReportPaginatedResultDto } from "../models/TransactionReportPaginatedResultDto";
import type { UniversalExportRequestDto } from "../models/UniversalExportRequestDto";
import type { UniversalExportResponseDto } from "../models/UniversalExportResponseDto";
import type { UsedCouponResultDtoPaginatedResultDto } from "../models/UsedCouponResultDtoPaginatedResultDto";
import type { VoucherType } from "../models/VoucherType";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export type KpiCategory = "KATA" | "EV" | "EVKATA";

export class AdminService {
  /**
   * @param from
   * @param to
   * @param type
   * @returns number OK
   * @throws ApiError
   */
  public static patchAdminUndeleteCompany(
    companyGuid?: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/admin/undeleteCompany",
      query: {
        companyGuid: companyGuid,
      },
    });
  }

  public static getAdminKpiAllAccountsCount(
    from?: string,
    to?: string,
    type?: KPIFilterType,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/kpi/allAccountsCount",
      query: {
        From: from,
        To: to,
        Type: type,
      },
    });
  }

  /**
   * @param from
   * @param to
   * @param type
   * @returns number OK
   * @throws ApiError
   */
  public static getAdminKpiActiveAccountsCount(
    from?: string,
    to?: string,
    type?: KPIFilterType,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/kpi/activeAccountsCount",
      query: {
        From: from,
        To: to,
        Type: type,
      },
    });
  }

  /**
   * @param from
   * @param to
   * @param type
   * @returns number OK
   * @throws ApiError
   */
  public static getAdminKpiDeletableAccountsCount(
    from?: string,
    to?: string,
    type?: KPIFilterType,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/kpi/deletableAccountsCount",
      query: {
        From: from,
        To: to,
        Type: type,
      },
    });
  }

  /**
   * @param voucherType
   * @param from
   * @param to
   * @param type
   * @returns number OK
   * @throws ApiError
   */
  public static getAdminKpiVoucherCount(
    voucherType?: VoucherType,
    from?: string,
    to?: string,
    type?: KPIFilterType,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/kpi/voucherCount",
      query: {
        VoucherType: voucherType,
        From: from,
        To: to,
        Type: type,
      },
    });
  }

  /**
   * @param from
   * @param to
   * @param type
   * @returns number OK
   * @throws ApiError
   */
  public static getAdminKpiInvoiceCount(
    from?: string,
    to?: string,
    type?: KPIFilterType,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/kpi/invoiceCount",
      query: {
        From: from,
        To: to,
        Type: type,
      },
    });
  }

  /**
   * @param genericSearchField
   * @param from
   * @param to
   * @param sorting
   * @param skip
   * @param pageSize
   * @param maxPageSize
   * @returns TransactionReportPaginatedResultDto OK
   * @throws ApiError
   */
  public static getAdminTransactionsReport(
    genericSearchField?: string,
    from?: string,
    to?: string,
    sorting?: string,
    skip?: number,
    pageSize?: number,
    maxPageSize?: number,
  ): CancelablePromise<TransactionReportPaginatedResultDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/transactionsReport",
      query: {
        GenericSearchField: genericSearchField,
        From: from,
        To: to,
        Sorting: sorting,
        Skip: skip,
        PageSize: pageSize,
        MaxPageSize: maxPageSize,
      },
    });
  }

  /**
   * @param transactionId
   * @returns PaymentTransactionLog OK
   * @throws ApiError
   */
  public static getAdminTransactionReport(
    transactionId: string,
  ): CancelablePromise<Array<PaymentTransactionLog>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/transactionReport/{transactionId}",
      path: {
        transactionId: transactionId,
      },
    });
  }

  /**
   * @param genericSearchField
   * @param sorting
   * @param skip
   * @param pageSize
   * @param maxPageSize
   * @returns ApplicationUserDtoPaginatedResultDto OK
   * @throws ApiError
   */
  public static getAdminApplicationUsers(
    genericSearchField?: string,
    sorting?: string,
    skip?: number,
    pageSize?: number,
    maxPageSize?: number,
  ): CancelablePromise<ApplicationUserDtoPaginatedResultDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/applicationUsers",
      query: {
        GenericSearchField: genericSearchField,
        Sorting: sorting,
        Skip: skip,
        PageSize: pageSize,
        MaxPageSize: maxPageSize,
      },
    });
  }

  /**
   * @param id
   * @returns ApplicationUserDto OK
   * @throws ApiError
   */
  public static getAdminApplicationUser(
    id: string,
  ): CancelablePromise<ApplicationUserDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/applicationUser/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @param id
   * @returns boolean OK
   * @throws ApiError
   */
  public static deleteAdminApplicationUser(
    id: string,
  ): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/applicationUser/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @param requestBody
   * @returns ApplicationUserResultDto OK
   * @throws ApiError
   */
  public static postAdminApplicationUser(
    requestBody?: ApplicationUserDto,
  ): CancelablePromise<ApplicationUserResultDto> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/applicationUser",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param genericSearchField
   * @param sorting
   * @param skip
   * @param pageSize
   * @param maxPageSize
   * @returns CouponPaginatedResultDto OK
   * @throws ApiError
   */
  public static getAdminCoupons(
    genericSearchField?: string,
    sorting?: string,
    skip?: number,
    pageSize?: number,
    maxPageSize?: number,
  ): CancelablePromise<CouponPaginatedResultDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/coupons",
      query: {
        GenericSearchField: genericSearchField,
        Sorting: sorting,
        Skip: skip,
        PageSize: pageSize,
        MaxPageSize: maxPageSize,
      },
    });
  }

  /**
   * @param applicationUserId
   * @returns CouponResultDto OK
   * @throws ApiError
   */
  public static getAdminApplicationusercoupons(
    applicationUserId: string,
  ): CancelablePromise<Array<CouponResultDto>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/applicationusercoupons/{applicationUserId}",
      path: {
        applicationUserId: applicationUserId,
      },
    });
  }

  /**
   * @returns Modul OK
   * @throws ApiError
   */
  public static getAdminModuls(): CancelablePromise<Array<Modul>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/moduls",
    });
  }

  /**
   * @param genericSearchField
   * @param from
   * @param to
   * @param sorting
   * @param skip
   * @param pageSize
   * @param maxPageSize
   * @returns UsedCouponResultDtoPaginatedResultDto OK
   * @throws ApiError
   */
  public static getAdminUsedcoupons(
    genericSearchField?: string,
    from?: string,
    to?: string,
    sorting?: string,
    skip?: number,
    pageSize?: number,
    maxPageSize?: number,
  ): CancelablePromise<UsedCouponResultDtoPaginatedResultDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/usedcoupons",
      query: {
        GenericSearchField: genericSearchField,
        From: from,
        To: to,
        Sorting: sorting,
        Skip: skip,
        PageSize: pageSize,
        MaxPageSize: maxPageSize,
      },
    });
  }

  /**
   * @param id
   * @returns Coupon OK
   * @throws ApiError
   */
  public static getAdminCoupon(id: string): CancelablePromise<Coupon> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/coupon/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @param requestBody
   * @returns CouponRequestResultDto OK
   * @throws ApiError
   */
  public static postAdminCoupon(
    requestBody?: CouponDto,
  ): CancelablePromise<CouponRequestResultDto> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/coupon",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param id
   * @returns boolean OK
   * @throws ApiError
   */
  public static deleteAdminCoupon(id?: string): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/coupon",
      query: {
        id: id,
      },
    });
  }

  /**
   * @param requestBody
   * @returns UniversalExportResponseDto OK
   * @throws ApiError
   */
  public static postAdminExport(
    requestBody?: UniversalExportRequestDto,
  ): CancelablePromise<UniversalExportResponseDto> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/export",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param requestBody
   * @returns ResultDto OK
   * @throws ApiError
   */
  public static postAdminDeliveryBillsToFileshare(
    requestBody?: Array<string>,
  ): CancelablePromise<Array<ResultDto>> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/deliveryBillsToFileshare",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  public static getCurrentSubscriptionCounts(): CancelablePromise<string[]> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/kpi/currentSubscriptionCounts",
      query: {},
    });
  }

  public static getAdminRenewalErrors(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/renewalErrors",
      query: {},
    });
  }

  public static getKpiCounts(
    category: KpiCategory,
    filterType: KPIFilterType,
  ): CancelablePromise<string> {
    const url = `/admin/kpi/${category}Count`;

    return __request(OpenAPI, {
      method: "GET",
      url: url,
      query: {
        Type: filterType,
      },
    });
  }
}
